<template>
  <div class="container">
    <div class="section us-page">
      <nav class="us-crumbs" aria-label="Ruta">
        <router-link :to="{ name: 'usermenu' }">Usuarios</router-link>
        <span>/</span>
        <span>Editar usuario</span>
      </nav>

      <div class="us-header profile">
        <span class="us-avatar profile-avatar">{{ initials }}</span>
        <div class="profile-text">
          <div class="profile-name">
            <span v-show="!editName" class="profile-who">
              {{ user.displayName }}
            </span>
            <b-input
              v-show="editName"
              v-model="user.displayName"
              class="profile-name-input"
              placeholder="Nombre"
            ></b-input>
            <button
              v-show="!editName"
              type="button"
              class="us-icon-btn"
              title="Editar nombre"
              aria-label="Editar nombre"
              @click="editName = true"
            >
              <i class="material-icons">edit</i>
            </button>
            <button
              v-show="editName"
              type="button"
              class="us-icon-btn"
              title="Guardar nombre"
              aria-label="Guardar nombre"
              @click="editUser(null, 'editName')"
            >
              <i class="material-icons">save</i>
            </button>
          </div>
          <p class="us-subtitle">{{ user.email }}</p>
        </div>
      </div>

      <div class="us-two">
        <div class="us-stack">
          <div class="box us-box">
            <div class="us-lead">
              <h2>Permisos</h2>
              <p>Los cambios se aplican al pulsar "Actualizar permisos".</p>
            </div>
            <permissions-form
              :claims="user.claims"
              @toggle="onToggleClaim"
            ></permissions-form>
            <div class="us-savebar">
              <p class="us-hint">Solo guarda esta sección.</p>
              <b-button type="is-dark" @click="editUser(null, 'editPermission')">
                Actualizar permisos
              </b-button>
            </div>
          </div>

          <div class="box us-box">
            <div class="us-lead">
              <h2>Empresas asignadas</h2>
              <p>
                El usuario puede pertenecer a varias empresas, pero solo una
                está seleccionada: es la que ve al entrar. Cada cambio se guarda
                al momento.
              </p>
            </div>
            <div class="company-list" role="radiogroup">
              <label
                v-for="item in empresasUser"
                :key="item._id"
                class="company-item"
                :class="{ 'is-selected': user.currentCompany === item._id }"
              >
                <span class="company-pick">
                  <input
                    type="radio"
                    name="current-company"
                    :checked="user.currentCompany === item._id"
                    @change="editUser(item, 'editCurrentCompany')"
                  />
                  <span class="company-text">
                    <span class="company-name">{{ item.nombre }}</span>
                    <span v-if="item.nit" class="company-nit">
                      NIT {{ item.nit }}
                    </span>
                  </span>
                </span>
                <span class="company-actions">
                  <span
                    v-if="user.currentCompany === item._id"
                    class="us-tag us-tag--admin"
                  >
                    Seleccionada
                  </span>
                  <button
                    v-show="showDelete"
                    type="button"
                    class="us-icon-btn is-danger"
                    title="Quitar empresa"
                    aria-label="Quitar empresa"
                    @click.prevent="editUser(item, 'deleteCompany')"
                  >
                    <i class="material-icons">delete</i>
                  </button>
                </span>
              </label>
            </div>
            <div class="us-inline">
              <div class="us-field">
                <label>Agregar empresa</label>
                <v-select
                  class="us-select"
                  label="nombre"
                  :options="empresas"
                  v-model="current"
                  placeholder="Seleccione una empresa"
                ></v-select>
              </div>
              <b-button @click="editUser(current, 'addCompany')">
                Agregar
              </b-button>
            </div>
          </div>

          <employee-picker
            v-if="user.claims.liderl"
            :employees="listempleados"
            :selected-id="user.empleado || ''"
            @load="traeempleados"
            @select="seleccionar"
          ></employee-picker>
        </div>

        <aside class="us-aside">
          <user-summary
            :user="user"
            :company-name="currentName"
            note="En esta página no hay un guardar general: cada sección guarda lo suyo."
          ></user-summary>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PermissionsForm from "../components/PermissionsForm.vue";
import UserSummary from "../components/UserSummary.vue";
import EmployeePicker from "../components/EmployeePicker.vue";
import { getInitials } from "../helpers";

export default {
  components: {
    vSelect,
    PermissionsForm,
    UserSummary,
    EmployeePicker,
  },
  data() {
    return {
      user: {
        currentCompany: "",
        companys: {},
        claims: {},
      },
      empresas: [],
      empresasUser: [],
      current: "",
      listempleados: [],
      editName: false,
    };
  },
  computed: {
    ...mapState(["idtoken"]),
    showDelete() {
      if (this.empresasUser.length > 1) {
        return true;
      } else {
        return false;
      }
    },
    initials() {
      return getInitials(this.user);
    },
    currentName() {
      const selected = this.empresasUser.filter(
        (k) => k._id === this.user.currentCompany,
      )[0];
      return (selected && selected.nombre) || "";
    },
  },
  methods: {
    onToggleClaim(key, value) {
      this.$set(this.user.claims, key, value);
    },
    seleccionar(d) {
      this.$set(this.user, "empleado", d._id);
    },
    async getUserandEmpresa(_this) {
      let resultUser;
      let resultEmpresa;
      try {
        resultUser = await apiServices.get(`/usermg/${_this.$route.params.id}`);
        const loaded = resultUser.data || {};
        if (!loaded.companys) loaded.companys = {};
        if (!loaded.claims) loaded.claims = {};
        _this.user = loaded;
        resultEmpresa = await apiServices.get(`/empresas`);

        const d = {
          _id: "",
          nombre: "",
          nit: "",
        };
        _this.empresas = [].concat([d], resultEmpresa.data);
        if (resultEmpresa && _this.user.companys) {
          const empresasUser = Object.keys(_this.user.companys);
          resultEmpresa.data.forEach((k) => {
            empresasUser.forEach((k1) => {
              if (k._id === k1) {
                _this.empresasUser.push(k);
              }
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async editUser(i, caso) {
      if (caso === "addCompany" && !(i && i._id)) {
        this.$store.dispatch("notify", {
          message: "Selecciona una empresa para agregar",
          type: "is-danger",
          duration: 4000,
        });
        return;
      }
      if (!this.user.companys) this.$set(this.user, "companys", {});
      if (caso === "deleteCompany") {
        this.$delete(this.user.companys, i._id);
      }
      if (caso === "addCompany") {
        this.$set(this.user.companys, i._id, { id: i._id });
        if (!this.user.currentCompany) this.user.currentCompany = i._id;
      }
      if (caso === "editName") {
        this.editName = false;
      }

      if (caso === "editCurrentCompany") {
        this.user.currentCompany = i._id;
      }

      this.empresasUser = [];
      const empresasUser = Object.keys(this.user.companys);
      this.empresas.forEach((k) => {
        empresasUser.forEach((k1) => {
          if (k._id === k1) {
            this.empresasUser.push(k);
          }
        });
      });
      try {
        const payload = Object.assign({}, this.user);
        if (!payload.currentCompany) delete payload.currentCompany;
        await apiServices.put(
          `/user/update/${this.$route.params.id}`,
          payload,
        );
        this.$store.dispatch("notify", {
          message: `El usuario fue editado con éxito`,
          type: "is-link",
        });

        if (caso === "editCurrentCompany") {
          const empresa = await apiServices.get(`/empresacredential`);
          this.$store.commit("refreshEmpresa", empresa.data);
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo editar el usuario`,
          type: "is-danger",
        });
      }
    },
    async traeempleados() {
      this.listempleados = [];
      let result;
      try {
        result = await apiServices.get(`/listliderempleados/cpy`);
        if (result.data) {
          this.listempleados = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    idtoken(nv) {
      if (nv) {
        this.getUserandEmpresa(this);
      }
    },
    "user.claims": {
      handler(newValue) {
        if (newValue && newValue.admin) {
          Object.keys(newValue).map((x) => {
            if (x !== "admin") {
              this.user.claims[x] = false;
            }
          });
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.idtoken) {
      this.getUserandEmpresa(this);
    }
  },
};
</script>

<style src="../styles.css"></style>

<style scoped>
.profile {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}

.profile-avatar {
  width: 56px;
  height: 56px;
  font-size: 19px;
}

.profile-text {
  flex: 1;
  min-width: 0;
}

.profile-name {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.profile-who {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
  color: #363636;
}

.profile-name-input {
  flex: 1;
  max-width: 420px;
}

.company-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.company-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.company-item.is-selected {
  border-color: #7957d5;
  background: #f7f4fb;
}

.company-pick {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.company-pick input {
  flex: none;
  width: 18px;
  height: 18px;
  accent-color: #510087;
}

.company-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.company-name {
  font-size: 14px;
  font-weight: 600;
  color: #363636;
}

.company-nit {
  font-size: 12px;
  color: #7a7a7a;
}

.company-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/views/EditUser.vue